import React, { FC } from 'react';
import { Grid, Column } from '@goldbely/explore-component-library';

import { Routes } from 'src/explore/services/Routes';

import { Link } from './elements/Link';

import styles from './index.module.sass';

type ILinksProps = {
  comingSoon: boolean;
};

export const Links: FC<ILinksProps> = ({ comingSoon }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>Plan Your Watch Party</h1>
    <Grid className={styles.grid}>
      <Column span={{ lg: 6 }}>
        <Link
          href="https://www.masters.com/en_US/bring-your-masters-best"
          src={comingSoon ? Routes.image.consumer( 'wl/tasteofthemasters/bring-your-masters-best.png' ) : Routes.image.consumer( 'wl/tasteofthemasters/bring-your-best-2026.jpg' )}
          title="Bring Your Masters Best"
          description="Spring is in the air. Celebrate with your best Masters party this April."
        />
      </Column>
      <Column span={{ lg: 6 }}>
        <Link
          href="https://www.pinterest.com/masterstournament"
          src={comingSoon ? Routes.image.consumer( 'wl/tasteofthemasters/gather-tournament-inspiration.jpg' ) : Routes.image.consumer( 'wl/tasteofthemasters/gather-tournament-inspiration-2026.jpg' )}
          title="Gather Tournament Inspiration"
          description="Visit our Pinterest page for inspiration to perfect your Masters set-up and watch in style."
        />
      </Column>
    </Grid>
  </div>
);
